import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBenefitMigration } from '../../hooks/useBenefitMigration';
import { BenefitMigrationTrackingPage } from '../../pages/BenefitMigrationTrackingPage';
const STEP_DURATION_MS = 2000;
export function MigrationCompletionTransition() {
    const { scope, isCurrent, onboarding } = useBenefitMigration();
    const navigate = useNavigate();
    const [step, setStep] = useState('cards');
    const requestOnboarding = onboarding?.request;
    useEffect(() => {
        if (!scope)
            return;
        const timer = setTimeout(() => {
            if (!isCurrent(scope))
                return;
            if (step === 'cards') {
                setStep('completed');
                return;
            }
            requestOnboarding?.(scope);
            navigate('/beneficios', { replace: true });
        }, STEP_DURATION_MS);
        return () => clearTimeout(timer);
    }, [step, scope, isCurrent, requestOnboarding, navigate]);
    return _jsx(BenefitMigrationTrackingPage, { completionStep: step });
}
